import { useCallback, useState } from "react";

/**
 * Device-level preference: whether the AppShell sidebar is collapsed to an
 * icon rail. Persisted in localStorage so it survives reloads. Like the
 * theme key it is intentionally NOT cleared on sign-out — it belongs to
 * the device, not the session.
 */
export const SIDEBAR_COLLAPSED_STORAGE_KEY = "sidebar.collapsed.v1";

function readInitial(): boolean {
  try {
    return localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function useSidebarCollapsed(): [boolean, () => void] {
  const [collapsed, setCollapsed] = useState<boolean>(readInitial);

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_STORAGE_KEY, next ? "1" : "0");
      } catch {
        /* storage disabled (Safari private) — preference reverts on reload */
      }
      return next;
    });
  }, []);

  return [collapsed, toggle];
}
